"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classNameGenerator = require("../../theming/classNameGenerator");
var _classnames = _interopRequireDefault(require("../ListItemBoxText/classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = (0, _classNameGenerator.generateComponentClassNames)({
  component: 'ListItem',
  children: ['Wrapper', 'Icon', {
    component: 'Icon',
    children: ['Wrapper']
  }],
  supportSelectors: [_classnames["default"]]
});